<template>
  <b-card >
    <b-button v-if="!edit_nameserver"
              class="col-12 mb-4"
              variant="default"
              @click="edit_nameserver = !edit_nameserver">
      Bearbeiten
    </b-button>
    <b-button v-if="edit_nameserver"
              variant="outline-danger"
              class="col-12 mb-4"
              @click="undo_changes">
      Abbrechen
    </b-button>
    <h3>Nameserver</h3>
    <b-row v-for="(item,index) in ns_keys"
           :key="index"
           class="mb-2"
           v-if="nameserver[item] && ['ns1','ns2'].includes(item)">
      <b-col >
        {{ $t('domain')[item] }}
      </b-col>
      <b-col v-if="edit_nameserver">
        <v-select @search="search_nameserver"
                  v-model="nameserver[item]"
                  :clearable="false"
                  @input="change_nameserver(item,$event), $forceUpdate()"
                  :options="nameserver_options">
        </v-select>
      </b-col>
      <b-col v-else>
        {{ nameserver[item]  ? nameserver[item] : 'option'}}
      </b-col>
    </b-row>
    <div class="m-4 text-center">
      <b-link @click="more_options = !more_options">{{more_options ? 'weniger...':'Optional' }}</b-link>
    </div>
    <b-row v-for="(item,index) in ns_keys"
           :key="index"
           class="mb-2"
           v-if="nameserver[item] && ['ns3','ns4','ns5'].includes(item) && more_options">
      <b-col >
        {{ $t('domain')[item] }}
      </b-col>
      <b-col v-if="edit_nameserver ">
        <v-select @search="search_nameserver"
                  v-model="nameserver[item]"
                  :clearable="false"
                  @input="change_nameserver(item,$event), $forceUpdate()"
                  :options="nameserver_options">
        </v-select>
      </b-col>
      <b-col v-else>
        {{ nameserver[item]  ? nameserver[item] : 'option'}}
      </b-col>
    </b-row>
  </b-card>

</template>

<script>
    import axios from "@/store/vue-axios"
    import Domain from "@/store/models/domain/domain"
    import DomainNameserver from "@/store/models/domain/domain_nameserver";
    import {UserConfigDefaults} from "@/store/models/layout/user_config";

    export default {
        name: "luma-domain-nameserver-selection",
        props:{
            config:Object,
            name:String,
            setup_mode:Boolean
        },
        data: () => ({
            ns_keys: DomainNameserver.nameserverKeys,
            nameserver: {},
            edit_nameserver:false,
            localChange:false,
            fall_back_config:null,
            more_options:false
        }),

        computed: {
            config_data() {
                return this.nameserver
            },
            nameserver_options(){
                return DomainNameserver.all().map(el=>el.servername)
            }
        },
        methods: {
            search_nameserver(search,loading){
                DomainNameserver.fetch(search)
            },
            undo_changes(){
                this.nameserver = JSON.parse(JSON.stringify(this.fall_back_config))
                this.edit_nameserver = false
                const x = DomainNameserver.nameserverKeys.map(el=>{
                    this.change_nameserver(el,this.nameserver[el])
                })
            },
            emit_local_change(user_config,edit){
                this.$emit('emit_local_change',user_config,edit)
            },
            change_nameserver(ns,val){
                let obj = {}
                if(this.name){
                    obj[ns]=val
                    obj['name']=this.name
                    console.log('CHANGED CONTACT', obj)
                    Domain.insertOrUpdate({data:obj})
                }
                if(this.setup_mode){
                    obj[ns]=val
                    obj['$id']=this.$userConfig.$id
                    console.log('CHANGED CONTACT', obj)
                    UserConfigDefaults.insertOrUpdate({data:obj})
                }
                this.localChange = true
                this.emit_local_change(obj,this.edit_nameserver)
            }
        },
        created() {
            const x = DomainNameserver.nameserverKeys.map(el=>{
                this.config[el] ? this.nameserver[el]=this.config[el] : this.nameserver[el]='option'
            })
            this.fall_back_config = JSON.parse(JSON.stringify(this.nameserver))
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/domain/setup_domain/luma-domain-nameserver-selection.vue